module.exports = __webpack_public_path__ + "static/media/drivers.24af1204.svg";